import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustedBy } from "@/components/site/TrustedBy";
import { Services } from "@/components/site/Services";
import { SocialCampaign } from "@/components/site/SocialCampaign";
import { Showreel } from "@/components/site/Showreel";
import { Portfolio } from "@/components/site/Portfolio";
import { ClientsHelped } from "@/components/site/ClientsHelped";
import { Marquee } from "@/components/site/Marquee";
import { RescueSlider } from "@/components/site/RescueSlider";
import { Process } from "@/components/site/Process";
import { WhySacramento } from "@/components/site/WhySacramento";
import { Testimonials } from "@/components/site/Testimonials";
import { HealthCheck } from "@/components/site/HealthCheck";
import { Pricing } from "@/components/site/Pricing";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Website Design Sacramento | Emergent Sacramento — Web, Branding, SEO & Marketing";
  }, []);

  // Scroll to a section when arriving with a hash (e.g. /#services from another page)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 100);
        }
      };
      setTimeout(() => tryScroll(), 50);
    }
  }, [location]);

  return (
    <div className="bg-ink text-white font-body min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <Services />
        <SocialCampaign />
        <Showreel />
        <Portfolio />
        <ClientsHelped />
        <Marquee />
        <RescueSlider />
        <Process />
        <WhySacramento />
        <Testimonials />
        <HealthCheck />
        <Pricing />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
